exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn-address[data-v-85c6cca4]:focus {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.addressbox-selected[data-v-85c6cca4] {\n  background-color: rgba(0, 0, 0, .08);\n  border: 2px solid #ccc;\n}\n.btn-link[data-v-85c6cca4] {\n  color: #6c757d;\n  text-decoration: none;\n}\n.btn-link[data-v-85c6cca4]:hover {\n  color: #21272d;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-85c6cca4","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/contracts/ContractList.vue
// module id = UuuA
// module chunks = 1